document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.tab-link');
    const items = document.querySelectorAll('.service-item-wrapper');

    tabs.forEach(tab => {
        tab.addEventListener('click', function() {
            const category = this.getAttribute('data-category');

            tabs.forEach(t => t.classList.remove('active'));
            this.classList.add('active');

            items.forEach(item => {
                if (category === 'all' || item.getAttribute('data-categories').includes(category)) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
        });
    });
});